import { render } from "./LivingUnitAmenityDetails.vue?vue&type=template&id=1f2e10d3"
import script from "./LivingUnitAmenityDetails.vue?vue&type=script&lang=js"
export * from "./LivingUnitAmenityDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__